import React from 'react';

import classes from './next_prev.module.css';

export interface NextPrevProps {
  next: string
  prev: string
  children?: React.ReactNode
}

export default function NextPrev({ next, prev, children }: NextPrevProps) {
  return <>
    <a className={ classes.prev } href={ prev } rel="noreferrer" />
    { children }
    <a className={ classes.next } href={ next } rel="noreferrer" />
  </>
}
